import React, { useState, useEffect } from "react";

import { TextField, Button, FormControl, Modal, Box } from "@mui/material";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { changeAuth } from "../../actions/loginAction";
import host from "../../host";
function CompanyProfile() {
  const [value, setValue] = useState();

  const [open1, setOpen1] = React.useState(false);
  const handleClose1 = () => setOpen1(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogOut = () => {
    navigate("/logout");
  };

  const [profilePicture, setProfilePicture] = useState(null);
  const [profilePictureUrl, setProfilePictureUrl] = useState(null);

  const [profile, setProfile] = useState(null);
  const [snackbar, setSnackbar] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const onClose = () => {
    setSnackbar(false);
  };

  const getProfile = () => {
    fetch(host.chaturl + `/user`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          // setIsLoaded(true);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        if (data) {
          setProfile(data);
          if (data.profile_image) {
            setProfilePicture(data.profile_image);
          }
          // setIsLoaded(true);
        }
      })
      .catch((err) => {
        console.log(err);
        //  setIsLoaded(true);
      });
  };

  useEffect(() => {
    getProfile();
  }, []);

  const uploadProfilePicture = (file) => {
    let mainQuery = `/user/upload_image`;
    let formData = new FormData();
    formData.append("file", file);
    fetch(host.chaturl + mainQuery, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: formData,
    })
      .then((res) => {
        return res.json();
      })
      .then(async (data) => {
        if (data.success) {
          setProfilePicture(URL.createObjectURL(file));
          setProfilePictureUrl(data.file_path);
          setSeverity("success");
          setMessage("Image uploaded successfully");
          setSnackbar(true);
        } else {
          setSeverity("error");
          setMessage(data.message);
          setSnackbar(true);
        }
      })
      .catch((err) => {
        console.log(err);
        setSeverity("error");
        setMessage("something went wrong");
        setSnackbar(true);
      });
  };

  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="card-summary-head">
            <div className="summary-title-tow">
              <h5 className="d-flex align-items-center "> User Profile</h5>
            </div>

            <Button startIcon={<ExitToAppIcon size="small" />} variant="outlined" style={{ textTransform: "capitalize" }} onClick={handleLogOut}>
              Sign Out
            </Button>
          </div>
          <div className="company-profile-wrapper">
            <div className="candidate-profile-left">
              <div className="company-image-wrapper">
                <div className="company-image">
                  {!profilePicture && (
                    <h4>
                      Upload your Profile Picture <br /> here
                    </h4>
                  )}
                  {profilePicture && <img src={profilePicture} />}
                </div>
                <div className="bulkbtn">
                  <div className="profilechange mt-0">
                    <label htmlFor="cover-photo">
                      <a className="btn btn-secondry  ">
                        <i className="las la-cloud-upload-alt" /> Upload Profile Picture{" "}
                      </a>
                      <input
                        type="file"
                        id="cover-photo"
                        accept="image/*"
                        onChange={(e) => {
                          uploadProfilePicture(e.target.files[0]);
                        }}
                      />
                    </label>
                  </div>
                </div>
                <div className="company-logo-discribe">
                  <span>Click on the ' Upload Profile Picture ' button to personalize your account with your own logo</span>
                </div>
              </div>
            </div>
            <div className="candidate-profile-detail">
              <div className="row">
                <div className="col-lg-8">
                  <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                      <div className="form-group">
                        <label>
                          User Name <span className="text-danger">*</span>
                        </label>
                        <FormControl fullWidth>
                          <TextField
                            size="small"
                            type="text"
                            value={profile && profile.fullname}
                            placeholder="Enter user name"
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </FormControl>
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                      <div className="form-group">
                        <label>
                          User Email <span className="text-danger">*</span>
                        </label>
                        <FormControl fullWidth>
                          <TextField
                            size="small"
                            type="text"
                            value={profile && profile.email}
                            placeholder="Enter user email "
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        </FormControl>
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                      <div className="form-group">
                        <label>
                          Phone Number <span className="text-danger">*</span>
                        </label>
                        <FormControl fullWidth>
                          <PhoneInput international countryCallingCodeEditable={false} defaultCountry="IN" value={profile && profile.phone_number} onChange={setValue} className="worldwidephone" />
                        </FormControl>
                      </div>
                    </div>
                    {/*}
                     <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                        <div className="form-group">
                           <label>Website   </label>
                           <FormControl fullWidth>
                              <TextField 
                                size='small'
                              type="text" 
                              placeholder=' '
                              value=""
                              InputProps={{
                                 readOnly: true,
                               }}
                             
                              />
                           </FormControl>
                        </div>
                     </div>
                   */}
                    {/*}
                     <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="form-group">
                           <label>Organization Token     </label>
                           <FormControl fullWidth>
                              <TextField 
                                size='small'
                              type="text" 
                              placeholder='Token'
                             
                              InputProps={{
                                 readOnly: true,
                               }}
                             
                              />
                           </FormControl>
                        </div>
                     </div>
                    */}
                    {/*}
                     <div className="submit-section mt-3 mb-3 text-center">
                        <button type="button" className="btn btn-primary submit-btn" onClick={active}> Save </button>
                     </div>
                     */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal open={open1} onClose={handleClose1} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box className=" commonpopup  modal-common  popup-w35  ">
          <div className="modal-body">
          <div className="popup_scroller">
            <div className="model-content text-center">
              <h3>Your you sure to save ? </h3>
            </div>
            <div className="modal-btn">
              <button className="btn btn-success btn-block  ">Confirm</button>
              <button className="btn btn-danger btn-block  " onClick={handleClose1}>
                Cancel
              </button>
            </div>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
}
export default CompanyProfile;
